import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { TextLink } from '@frontend/design-system';

type Props = {
  onBackClick: () => void;
};

export const BulkMessageEditorFooter = ({ onBackClick }: Props) => {
  const { t } = useTranslation('bulk-messaging');

  return (
    <div
      css={{
        gridArea: 'footer',
        display: 'grid',
        gridTemplateColumns: 'auto 1fr',
        alignItems: 'center',
        padding: theme.spacing(2),
        columnGap: theme.spacing(1),
        borderTop: `solid 1px ${theme.colors.neutral20}`,
        background: theme.colors.white,
        position: 'fixed',
        width: '100%',
        bottom: 0,
        zIndex: theme.zIndex.middle + 1,
        left: 0,
      }}
    >
      <TextLink onClick={() => onBackClick()}>{t('Back')}</TextLink>
    </div>
  );
};
